// Copyright ©️ 2026 eVolve MEP, LLC

import { useEffect, useMemo } from 'react';

import { useEvolvePaginatedGet } from '@evolvemep/api-ts';
import { Accordion, Card, Text } from '@mantine/core';

import { TaskTypeList } from 'modules/Shop/ShopSetup/WorkCellSetup/ShopSetupPage/TaskTypes/TaskTypeList';

import { useTaskTypes } from './useTaskTypes';

// this type standardizes an identifier for the group where task types with no taskTypeGroupId are displayed.
export const undefinedGroupKey = '_$undefinedGroupKey' as const;

export const UndefinedTaskTypeGroupSection = ({
  hideDelete,
  isWorkCellMapping,
}: {
  hideDelete?: boolean;
  isWorkCellMapping?: boolean;
}) => {
  const { searchText, onTaskSelect, shopConfiguration } = useTaskTypes();

  const defaultOpts = useMemo(
    () => ({
      defaultConfig: {
        params: {
          hasNoTaskTypeGroup: true,
          taskTypeName: searchText,
          shopConfigurationId: shopConfiguration?.shopConfigurationId,
        },
      },
    }),
    [searchText, shopConfiguration?.shopConfigurationId],
  );
  const {
    data: undefinedGroupTasks,
    entireCount,
    loading,
    setDefaultOpts,
    fetchNextPage,
  } = useEvolvePaginatedGet('shop/taskType', defaultOpts);
  useEffect(() => setDefaultOpts(defaultOpts), [defaultOpts, setDefaultOpts]);

  return (
    <Card withBorder radius={5} mb={5} p={0}>
      <Accordion.Item value={undefinedGroupKey} w="100%">
        <Accordion.Control w="100%" flex={1}>
          <Text size="xs" fw="bold">
            Ungrouped Tasks
          </Text>
        </Accordion.Control>
        <Accordion.Panel>
          <TaskTypeList
            loading={loading}
            onTaskSelect={onTaskSelect}
            groupTasks={undefinedGroupTasks}
            entireCount={entireCount}
            nothingFoundText="No tasks to display."
            fetchNextPage={fetchNextPage}
            hideDelete={hideDelete}
            isWorkCellMapping={isWorkCellMapping}
          />
        </Accordion.Panel>
      </Accordion.Item>
    </Card>
  );
};
